import React, { useState } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';
import AuthNavbar from '../components/AuthNavbar';
import Footer from '../components/Footer'; 
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showSuccess, setShowSuccess] = useState(false); 
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  // --- NEW: FORGOT PASSWORD STATES ---
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [resetStep, setResetStep] = useState(1); // 1 = Enter Email, 2 = Enter OTP & New Password
  const [resetEmail, setResetEmail] = useState('');
  const [resetOtp, setResetOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post('/auth/login', { email, password });
      
      // Save data
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      
      // Setup for Modal
      setUserName(res.data.user.name);
      setShowSuccess(true);

      const role = res.data.user.role;

      // Delayed navigation to show off the success modal
      setTimeout(() => {
        if (role === 'admin') navigate('/admin-dashboard');
        else if (role === 'mechanic') navigate('/mechanic-dashboard');
        else navigate('/user-dashboard');
      }, 2000);

    } catch (err) {
      alert(err.response?.data?.msg || "Login Failed");
    }
  };

  // --- NEW: FORGOT PASSWORD HANDLERS ---
  const handleSendResetOTP = async (e) => {
    e.preventDefault();
    try {
      await API.post('/auth/forgot-password', { email: resetEmail });
      alert("Password reset OTP sent! Please check your email.");
      setResetStep(2); // Move to OTP input screen
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to send OTP. Check if email is correct.");
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      await API.post('/auth/reset-password', { 
        email: resetEmail, 
        otp: resetOtp, 
        newPassword 
      });
      alert("Password reset successfully! You can now login with your new password.");
      
      // Close modal and clear form
      setShowForgotModal(false);
      setResetStep(1);
      setResetEmail('');
      setResetOtp('');
      setNewPassword('');
    } catch (err) {
      alert(err.response?.data?.msg || "Failed to reset password. Invalid OTP.");
    }
  };

  const closeForgotModal = () => {
    setShowForgotModal(false);
    setResetStep(1);
    setResetEmail('');
    setResetOtp('');
    setNewPassword('');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AuthNavbar />
      
      <div className="login-page-container" style={{ flex: 1, padding: '2rem 1rem' }}>
        <div className="hero-content">
          <div className="status-badge">
            <span className="icon">⚠️</span> Roadside Assistance Redefined
          </div>
          <h1>Stuck on the road?</h1>
          <h1 className="highlight-text">We've got your back.</h1>
          <p className="description">
            Connect with nearby mechanics instantly. Fast, reliable, and secure 
            roadside assistance whenever you need it.
          </p>
        </div>

        <div className="login-form-card">
          <form onSubmit={handleLogin} className="form-stack">
            <input 
              type="email" 
              placeholder="Email" 
              className="styled-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
            <input 
              type="password" 
              placeholder="Password" 
              className="styled-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
            
            {/* NEW: FORGOT PASSWORD LINK */}
            <div style={{ textAlign: 'right', marginTop: '-10px', marginBottom: '10px' }}>
              <button 
                type="button" 
                onClick={() => setShowForgotModal(true)}
                style={{ background: 'none', border: 'none', color: '#007bff', padding: '0', fontSize: '14px', fontWeight: '500' }}
              >
                Forgot Password?
              </button>
            </div>
            
            <div className="action-buttons">
              <button type="submit" className="btn-solid-blue">Login</button>
              <button 
                type="button" 
                className="btn-outline-gray" 
                onClick={() => navigate('/register')}
              >
                Register
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* --- NEW: FORGOT PASSWORD MODAL --- */}
      {showForgotModal && (
        <div className="modal-overlay">
          <div className="modal-content card">
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '20px' }}>
              <h3 style={{ margin: 0 }}>Reset Password</h3>
              <button style={{ background: 'none', border: 'none', fontSize: '24px' }} onClick={closeForgotModal}>×</button>
            </div>

            {resetStep === 1 ? (
              <form onSubmit={handleSendResetOTP} className="form-stack">
                <p style={{ color: '#666', fontSize: '14px', marginBottom: '15px' }}>
                  Enter your registered email address and we will send you a 6-digit code to reset your password.
                </p>
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="styled-input"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)} 
                  required 
                />
                <button type="submit" className="btn-solid-blue" style={{ width: '100%', marginTop: '10px' }}>
                  Send Reset Code
                </button>
              </form>
            ) : (
              <form onSubmit={handleResetPassword} className="form-stack">
                <p style={{ color: '#666', fontSize: '14px', marginBottom: '15px' }}>
                  We sent a code to <strong>{resetEmail}</strong>. Enter it below along with your new password.
                </p>
                <input 
                  type="text" 
                  placeholder="6-Digit OTP" 
                  className="styled-input"
                  style={{ textAlign: 'center', letterSpacing: '3px', fontWeight: 'bold' }}
                  maxLength="6"
                  value={resetOtp}
                  onChange={(e) => setResetOtp(e.target.value)} 
                  required 
                />
                <input 
                  type="password" 
                  placeholder="New Password" 
                  className="styled-input"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)} 
                  required 
                />
                <button type="submit" className="btn-success" style={{ width: '100%', marginTop: '10px' }}>
                  Confirm New Password
                </button>
                <button 
                  type="button" 
                  className="btn-outline-gray" 
                  onClick={() => setResetStep(1)}
                  style={{ width: '100%', marginTop: '10px' }}
                >
                  Back
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* SUCCESS MODAL POP-UP */}
      {showSuccess && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ textAlign: 'center', borderTop: '8px solid #28a745' }}>
            <div style={{ fontSize: '50px', color: '#28a745', marginBottom: '10px' }}>✔️</div>
            <h2 style={{ margin: '0' }}>Login Successful!</h2>
            <p style={{ color: '#666', border: 'none' }}>Welcome back, <strong>{userName}</strong></p>
            <p style={{ fontSize: '14px', color: '#888', border: 'none' }}>Redirecting to your dashboard...</p>
          </div>
        </div>
      )}
      
      <Footer /> 
    </div>
  );
};

export default Login;